'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$23() {
  this.aye = null;
  this.ayf = false;
}
export { $c_Lpresto_AgentView$$anon$23 as $c_Lpresto_AgentView$$anon$23 };
$p = $c_Lpresto_AgentView$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$23;
/** @constructor */
function $h_Lpresto_AgentView$$anon$23() {
}
export { $h_Lpresto_AgentView$$anon$23 as $h_Lpresto_AgentView$$anon$23 };
$h_Lpresto_AgentView$$anon$23.prototype = $p;
$p.P = (function() {
  if ((!this.ayf)) {
    this.aye = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T5($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.ayf = true;
  }
  return this.aye;
});
var $d_Lpresto_AgentView$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$23, "presto.AgentView$$anon$23", ({
  DS: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$23 as $d_Lpresto_AgentView$$anon$23 };
//# sourceMappingURL=presto.-Agent-View$$anon$23.js.map
